import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Thumbnails from './ui/thumbnails/thumbnails';
import GoBackButton from './ui/buttons/go_back';

export default class SeeAllSlides extends Component {
  render() {
    const { adsState, handleGoBackClick, handleThumbnailClick,
      openerImage, slideshowSections } = this.props;
    return (
      <div className="see-all-slides">
        <GoBackButton handleClick={handleGoBackClick} />
        <Thumbnails adsState={adsState}
          handleThumbnailClick={handleThumbnailClick}
          openerImage={openerImage}
          slideshowSections={slideshowSections}
        />
      </div>
    );
  }
}

SeeAllSlides.propTypes = {
  adsState: PropTypes.object.isRequired,
  handleGoBackClick: PropTypes.func.isRequired,
  handleThumbnailClick: PropTypes.func.isRequired,
  openerImage: PropTypes.object.isRequired,
  slideshowSections: PropTypes.arrayOf(PropTypes.object).isRequired
};
